var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.$route.query.type === "edit"
                ? _vm.$t("payment_links.edit_payment_link")
                : _vm.$t("payment_links.create_payment_link"),
            visible: _vm.dialogVisible,
            width: "739px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.closeDialog,
          },
        },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$route.query.type === "edit"
                    ? _vm.$t("payment_links.update_successful_tips")
                    : _vm.$t("payment_links.create_successful_tips")
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            { staticStyle: { width: "fit-content", margin: "0 auto" } },
            [
              _c("el-input", {
                staticClass: "from-input",
                attrs: {
                  placeholder: _vm.$t("payment_links.link_no"),
                  size: "small",
                  type: "text",
                  clearable: "",
                },
                model: {
                  value: _vm.form.link_url,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.form,
                      "link_url",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.link_url",
                },
              }),
              _c(
                "el-button",
                {
                  staticClass: "copy-text",
                  attrs: {
                    type: "info",
                    size: "small",
                    "data-clipboard-text": _vm.form.link_url,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onClickCopyBtn(".copy-text", "Link")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("payment_links.copy_link")))]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "img" }, [
            _c("img", { attrs: { src: _vm.form.link_qr_base64, alt: "" } }),
          ]),
          _c(
            "div",
            { staticClass: "dialog-footer" },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-download",
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.onClickDownloadBtn },
                },
                [_vm._v(_vm._s(_vm.$t("payment_links.download_qr_code")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }